// Components
import { Box, Text } from 'yard-utilities/components'

// Styles
import styles from './LocationTag.module.sass'

const LocationTag = ({
  children,
  location
}: {
  children: string
  location: string
}) => {
  return (
    <Box
      borderRadius={{ sm: [8] }}
      padding={{ sm: [8] }}
      backgroundColor="teal-10"
      className={`${styles.locationTag} ${
        location === children ? styles.active : ''
      }`}
    >
      <Text tagName="p" variant="body-4" transform="capitalize">
        📌 {children}
      </Text>
    </Box>
  )
}

export default LocationTag
